module.exports = require('./style.js');